import { $apiClient } from '../../utils/request';

export default function refreshTokenService(payload: string) {
  const url = 'api/v1/auth/refresh-token';
  return $apiClient.post(url, { rememberToken: payload });
}
